import React, { useState, useContext }  from 'react';
import styled from 'styled-components';

import Img from 'react-cool-img';
import Dropdown from './Dropdown';
import QuantitySelector from './QuantitySelector';

import { CheckoutContext } from '../../contexts/checkout-context';

//For Toastify
import { toast } from 'react-toastify';
import {DESKTOP_BREAKPOINT} from "../../styles/breakpoints";

const Wrapper = styled.div`
    width: 75%;
    min-height: 65vh;
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(2, 1fr);
    color: var(--darkgreen);
    font-family: IBM Plex Mono Regular;
    margin-top: 5vh;
    
    @media (min-width: ${DESKTOP_BREAKPOINT}) {
        gap: 72px;
    }

    .image{
        background-color: white;
        padding: 10vh 5vh;
        grid-area: 1 / 1 / 3 / 2;

        img{
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
        @media(max-width: 1000px) {
            padding: 0;
            width: 50vw;
            height: 100%;
            max-width: 400px;
            grid-area: 1 / 1 / 2 / 2;
        }
    }

    .metadata{
        grid-area: 1 / 2 / 2 / 3;
        @media(max-width: 1000px) {
            grid-area: 1 / 2 / 2 / 3;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        &--bottom {
            grid-area: 2 / 2 / 3 / 3;
            @media(max-width: 1000px) {
                grid-area: 2 / 1 / 3 / 3;
            }
        }
    }

    .type{
        min-width: 125px;
        margin-bottom: 10px;
        background-color: ${props => props.type === "Indica" ? "rgba(162, 199, 179, 0.6)" :
                            props.type === "Sativa" ? "rgba(175, 207, 252, 0.6)" :
                            "rgba(255, 227, 179, 0.6)"};
        padding: 0.75vh 1.5vh;
        width: max-content;
        display: flex;
        align-items: center;
        justify-content: center;
        
        p{
            font-family: Druk Wide Bold;
            margin: 0;
            font-size: calc(0.65vh + 0.65vw);
            text-align: center;
            color: ${props => props.type === "Indica" ? "#597A68" :
                            props.type === "Sativa" ? "#3686F7" :
                            "#FFBA40"};
            text-transform: uppercase;
            letter-spacing: 3px;
        }

        @media(max-width: 1000px) {
            min-width: auto;
            width: fit-content;
            padding: 3px 6px;
            p{
                font-size: 10px;
                padding: 0.35vh 1vh;
                letter-spacing: 2px;
            }
        }
    }

    .brand{
        font-size: 2.5vh;
        font-weight: 600;
        opacity: 0.8;
        text-transform: uppercase;
    }

    .product{
        line-height: 100%;
        margin-top: 2vh;
        font-weight: 800;
        font-size: 36px;
        word-wrap: normal;
        margin-bottom: 3.5vh;
    }

    .make{
        display: flex;
        align-items: center;

        p{
            margin: 0;
            margin-right: 2vh;
            width: fit-content;
            padding: 10px 20px;
            background-color: white;
            border: 1px solid var(--darkgreen);
            text-align: center;
        }
    }

    .effects{
        margin-top: 3vh;
        font-weight: 500;
        text-transform: capitalize;
    }

    .purchase{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-top: 3vh;
        border-top: 1px solid rgba(68, 105, 97, 0.5);

        @media(max-width: 1000px) {
            justify-content: flex-start;
            border-top: none;
            grid-area: 1 / 1 / 3 / 3;
            margin-top: 3vh;
        }
        .cart{
            margin-top: 3vh;
            align-self: center;
            width: 100%;
            background-color: var(--darkgreen);
            padding: 1.5vh;
            outline: none;
            border: none;
            font-family: Druk Wide Bold;
            font-size: 24px;
            font-weight: 500;
            text-transform: uppercase;
            color: white;
            transition: 350ms background-color;

            @media(max-width: 1000px) {
                width: 50%;
                margin-top: 0;
                margin-bottom: 5vh;
                font-size: 12px;
                padding: 2vh;
            }

            &:hover{
                background-color: #5b8a7f;
                cursor: pointer;
            }
        }
        .section{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            min-width: 7.5vw;
            @media(max-width: 1000px) {
                width: 50%;
                margin-bottom: 5vh;
            }

            .label{
                margin-top: 0;
                text-transform: capitalize;
                margin-bottom: 0.5vh;
            }
        }

    }

    .price{
        padding-bottom: 5px;
        margin-top: 5px;
        display: flex;
        align-items: center;
        max-width: 65%;
        
        font-family: IBM Plex Mono Bold;

        .old{
            text-decoration: line-through;
            font-size: 2vh;
            opacity: 0.5;
            margin-left: 1vw;
        }

        p{
            margin: 0;
            font-size: 2.5vh;
        }
    }

    @media(max-width: 1000px)
    {
        min-height: 0;
        width: 90%;
        position: relative;
        
        .brand{
            font-size: 14px;
            margin-top: 1.25vh;
        }
        
        .product{
            font-size: 16px;
            margin-bottom: 1vh;
            margin-top: 1vh;
        }
        
        .make{
            align-items: flex-start;
            flex-direction: column;

            p{
                padding: 5px 10px;
                font-size: 10px;
                margin-top: 1vh;
                width: 100%;
            }
        }

        .effects{
            margin-bottom: 1vh;
            margin-top: 1.5vh;
            font-size: 1.5vh;
        }
    }
`;

export default function Details({ product })
{
    const [amountindex, setAmountIndex] = useState(0);
    const [quantity, setQuantity] = useState(1);

    const { addToCart, currentRetailer } = useContext(CheckoutContext);

    let thcMake = "THC: "
    let cbdMake = "CBD: "

    if(product?.potencyThc?.formatted && product?.potencyThc?.formatted !== "")
    {
        thcMake += product?.potencyThc?.formatted.split(" ").join("");
    }
    else
    {
        thcMake += "0%";
    }

    if(product?.potencyCbd?.formatted && product?.potencyCbd?.formatted !== "")
    {
        cbdMake += product?.potencyCbd?.formatted.split(" ").join("");
    }
    else
    {
        cbdMake += "0%";
    }

    const onHandleAddToCart = () => {
        const idAtStore = product?.ids?.find((storeData) => storeData.retailerId === currentRetailer ).id;

        addToCart(product.id, quantity, product?.variants[amountindex].option);
    }

    return(
        <Wrapper type={product?.strainType}>

            <div className="image">
                <Img src={product?.image} alt={product?.name}/>
            </div>
            

            <div className="metadata">
                {(product?.strainType && product.strainType !== 'N/A' && product.strainType !== 'NOT_APPLICABLE') && <div className="type">
                    <p>{product?.strainType?.toLowerCase().replace("_", " ")}</p>
                </div>}
                <p className="brand">{product?.brand.name}</p>
                <p className="product">{product?.name}</p>
                <div className="make">
                    <p>{thcMake}</p>
                    <p>{cbdMake}</p>
                </div>
                <div className="effects">
                    Effects: { product?.effects?.length > 0 ? product?.effects?.join(", ").toLowerCase() : 'N/A' }
                </div>
            </div>
            <div className="metadata metadata--bottom">
                <div className="purchase">
                    <div className="section">
                        <p className="label">Total Weight</p>
                        <Dropdown amount={product?.variants[amountindex].option} setAmountIndex={setAmountIndex} variants={product?.variants}/>
                    </div>
                    <div className="section">
                        <p className="label">Quantity</p>
                        <QuantitySelector quantity={quantity} setQuantity={setQuantity}/>
                    </div>
                    <div className="section">
                        <p className="label">Price</p>
                        <div className="price">
                            {product?.variants[amountindex].priceMed !== product?.variants[amountindex].priceRec ? (
                                <>
                                    <p>${product?.variants[amountindex].priceMed}</p>
                                    <p className="old">${product?.variants[amountindex].priceRec}</p>
                                </>
                              )
                              : (
                                <p>${product?.variants[amountindex].priceRec}</p>
                              )
                            }
                        </div>
                    </div>
                    <button className="cart" onClick={onHandleAddToCart}>Add To Cart</button>
                </div>
            </div>

        </Wrapper>
    )
}